/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Col_SourceInputs */

const en_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const de_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle`)
};

const fr_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source`)
};

const es_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fuente`)
};

const it_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonte`)
};

const nl_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bron`)
};

const pl_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Źródło`)
};

const fi_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähde`)
};

const da_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kilde`)
};

const sv_salary_col_source = /** @type {(inputs: Salary_Col_SourceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Källa`)
};

/**
* | output |
* | --- |
* | "Source" |
*
* @param {Salary_Col_SourceInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_col_source = /** @type {((inputs?: Salary_Col_SourceInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Col_SourceInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_col_source(inputs)
	if (locale === "fr") return fr_salary_col_source(inputs)
	if (locale === "es") return es_salary_col_source(inputs)
	if (locale === "it") return it_salary_col_source(inputs)
	if (locale === "nl") return nl_salary_col_source(inputs)
	if (locale === "pl") return pl_salary_col_source(inputs)
	if (locale === "fi") return fi_salary_col_source(inputs)
	if (locale === "da") return da_salary_col_source(inputs)
	if (locale === "sv") return sv_salary_col_source(inputs)
	return en_salary_col_source(inputs)
});